module.exports = __webpack_public_path__ + "static/img/1-1Z5241P932131.bbdbfa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5241P932131.png
// module id = JyHN
// module chunks = 0